/* eslint-disable no-unused-vars */
import { Tooltip, withStyles } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import PropTypes from "prop-types";
import * as React from "react";
import { Draggable } from "react-beautiful-dnd";
import { AiOutlineMinus } from "react-icons/ai";
import * as CommonValues from "./utils/common-values";

/* eslint-enable no-unused-vars */

export class MTableHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lastX: 0,
      maxColumnWidth: 250,
      resizingColumnDef: undefined,
    };
  }

  // shouldComponentUpdate(nextProps, nextState){
  //   return !equal(nextProps, this.props) || !equal(nextState, this.state);
  // }

  componentDidMount() {
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
  }
  handleMouseDown = (e, columnDef) => {
    this.setState({
      lastAdditionalWidth: columnDef.tableData.additionalWidth,
      lastX: e.clientX,
      resizingColumnDef: columnDef,
    });
  };

  handleMouseMove = (e) => {
    if (!this.state.resizingColumnDef) {
      return;
    }

    let additionalWidth =
      this.state.lastAdditionalWidth + e.clientX - this.state.lastX;

    additionalWidth = Math.min(
      this.state.resizingColumnDef.maxWidth || additionalWidth,
      additionalWidth
    );

    if (
      this.state.resizingColumnDef.tableData.additionalWidth !== additionalWidth
    ) {
      this.props.onColumnResized(
        this.state.resizingColumnDef.tableData.id,
        additionalWidth
      );
    }
  };
  handleMouseUp = (e) => {
    this.setState({ resizingColumnDef: undefined });
  };
  getstatWidth(columnDef) {
    let stateWidth = {};
    if (this.props.columStatWidth && this.props.columStatWidth.length !== 0) {
      this.props.columStatWidth.forEach((item) => {
        if (item.Name === columnDef.field) stateWidth = item;
      });
    }
    return stateWidth;
  }
  getGreater = (array, leng) => {
    var largest = 0;

    for (let i = 0; i <= array.length; i++) {
      if (array[i] > largest) {
        largest = array[i];
      }
    }

    return leng > largest ? leng : largest;
  };

  handleFixWidth = (columnDef, exp) => {
    let lengthDetail = [];
    let lastItem = this.props.columns[this.props.columns?.length - 1];
    const { data } = this.props;
    const buffer = 5;

    data.forEach((item) => {
      let int = item[columnDef.field]?.length ?? 0;
      lengthDetail.push(int);
    });
    let titleLen = columnDef?.title?.length;
    let larger = this.getGreater(lengthDetail, titleLen);

    if (larger > 0) {
      let calc =
        lastItem.field === columnDef.field ? larger * 7 + 60 : larger * 7 + 30;
      return (calc > this.state.maxColumnWidth ? this.state.maxColumnWidth : calc) + buffer;
    } else {
      return 50;
    }
  };

  getCellStyle = (columnDef) => {
    let width = "";
    let customWidth = "";
    let modifiedWidth = "";

    // if (statWidth && statWidth.Width > 0) {
    //   customWidth = `calc((100% - (${
    //     this.props.scrollWidth - statWidth.Width
    //   }px)))`;
    //   let dif = parseInt(statWidth.Width) - parseInt(statWidth.MinWidth);
    //   if (columnDef.tableData.additionalWidth < 0) {
    //     if (Math.abs(columnDef.tableData.additionalWidth) <= dif) {
    //       modifiedWidth = `calc(${customWidth} + ${columnDef.tableData.additionalWidth}px)`;
    //     } else {
    //       modifiedWidth = `calc(${customWidth} + ${-Math.abs(dif)}px)`;
    //     }
    //   } else {
    //     modifiedWidth = `calc(${customWidth} + ${columnDef.tableData.additionalWidth}px)`;
    //   }
    //   width = CommonValues.reducePercentsInCalc(
    //     modifiedWidth,
    //     this.props.scrollWidth
    //   );
    // } else {
    if (this.props.columns.length > 2) {
      if (this.props.fitWidth !== 2) {
        if (columnDef.type === "boolean") {
          customWidth = `calc((100% - (${this.props.scrollWidth - 60}px)))`;
        } else if (columnDef.type === "numeric") {
          customWidth = `calc((100% - (${this.props.scrollWidth - 124}px)))`;
        } else if (
          columnDef.type === "date" ||
          columnDef.type === "date_time"
        ) {
          customWidth = `calc((100% - (${this.props.scrollWidth - 171}px)))`;
        } else {
          customWidth = `calc((100% - (0px)) / ${6})`;
        }
        // if (this.props.actions && this.props.actions.length !== 0) {
        //   customWidth = `calc((100% - (91px)) / ${this.props.columns.length})`;
        // } else {
        //   customWidth = columnDef.tableData.width;
        // }
      } else {
        let fixlen = this.handleFixWidth(columnDef);
        if (columnDef.type === "boolean") {
          let numLen = fixlen < 60 ? 60 : fixlen;
          customWidth = `calc((100% - (${this.props.scrollWidth - numLen}px)))`;
        } else if (columnDef.type === "numeric") {
          let numLen = fixlen < 121 ? 121 : fixlen;
          customWidth = `calc((100% - (${this.props.scrollWidth - numLen}px)))`;
        } else if (
          columnDef.type === "date" ||
          columnDef.type === "date_time"
        ) {
          let dateLen = fixlen < 171 ? 171 : fixlen;
          customWidth = `calc((100% - (${this.props.scrollWidth - dateLen
            }px)))`;
        } else {
          customWidth = `calc((100% - (${this.props.scrollWidth - fixlen}px)))`;
        }
      }
      modifiedWidth = `calc(${customWidth} + ${columnDef.tableData.additionalWidth}px)`;

      width = CommonValues.reducePercentsInCalc(
        modifiedWidth,
        this.props.scrollWidth
      );
    } else {
      width = CommonValues.reducePercentsInCalc(
        columnDef.tableData.width,
        this.props.scrollWidth
      );
    }

    // }

    const style = {
      ...this.props.headerStyle,
      ...columnDef.headerStyle,
      boxSizing: "border-box",
      width: width,
      maxWidth: columnDef.maxWidth,
      whiteSpace: "nowrap",

      overflow: "hidden",
      textOverflow: "ellipsis",
      minWidth: 20,
    };
    if (
      this.props.options.tableLayout === "fixed" &&
      this.props.options.columnResizable &&
      columnDef.resizable !== false
    ) {
      style.paddingRight = 2;
    }

    return style;
  };

  renderHeader() {
    const size = this.props.options.padding === "default" ? "medium" : "small";

    const mapArr = this.props.columns
      .filter(
        (columnDef) =>
          !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)
      )
      .sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder)
      .map((columnDef, index) => {
        let content = columnDef.title;
        if (this.props.draggable) {
          content = (
            <Draggable
              key={columnDef.tableData.id}
              draggableId={columnDef.tableData.id.toString()}
              index={index}
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  {columnDef.title}
                </div>
              )}
            </Draggable>
          );
        }

        if (columnDef.sorting !== false && this.props.sorting) {
          content = (
            <TableSortLabel
              IconComponent={this.props.icons.SortArrow}
              active={this.props.orderBy === columnDef.tableData.id}
              direction={this.props.orderDirection || "asc"}
              onClick={() => {
                const orderDirection =
                  columnDef.tableData.id !== this.props.orderBy
                    ? "asc"
                    : this.props.orderDirection === "asc"
                      ? "desc"
                      : this.props.orderDirection === "desc" &&
                        this.props.thirdSortClick
                        ? ""
                        : this.props.orderDirection === "desc" &&
                          !this.props.thirdSortClick
                          ? "asc"
                          : this.props.orderDirection === ""
                            ? "asc"
                            : "desc";
                this.props.onOrderChange(
                  columnDef.tableData.id,
                  orderDirection
                );
              }}
            >
              {content}
            </TableSortLabel>
          );
        }

        if (columnDef.tooltip) {
          content = (
            <Tooltip title={columnDef.tooltip} placement="bottom">
              <span>{content}</span>
            </Tooltip>
          );
        }

        if (
          this.props.options.tableLayout === "fixed" &&
          this.props.options.columnResizable &&
          columnDef.resizable !== false
        ) {
          content = (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flex: 1 }}>{content}</div>
              <div></div>
              <AiOutlineMinus
                style={{
                  cursor: "col-resize",
                  fontSize: 15,
                  transform: "rotate(90deg)",
                  color:
                    this.state.resizingColumnDef &&
                      this.state.resizingColumnDef.tableData.id ===
                      columnDef.tableData.id
                      ? this.props.theme.palette.primary.main
                      : "#b8b5b5",
                }}
                onMouseDown={(e) => this.handleMouseDown(e, columnDef)}
              />
            </div>
          );
        }

        const cellAlignment =
          columnDef.align !== undefined
            ? columnDef.align
            : ["numeric", "currency"].indexOf(columnDef.type) !== -1
              ? "right"
              : "left";
        return (
          <TableCell
            key={columnDef.tableData.id}
            align={cellAlignment}
            s
            className={this.props.classes.tableHeader}
            style={this.getCellStyle(columnDef)}
            size={size}
          >
            {content}
          </TableCell>
        );
      });
    return mapArr;
  }

  renderActionsHeader() {
    const localization = {
      ...MTableHeader.defaultProps.localization,
      ...this.props.localization,
    };
    const width = CommonValues.actionsColumnWidth(this.props);
    return (
      <TableCell
        key="key-actions-column"
        padding="checkbox"
        className={this.props.classes.tableHeader}
        style={{
          ...this.props.headerStyle,
          width: width,

          textAlign: "center",

          boxSizing: "border-box",
        }}
      >
        <TableSortLabel hideSortIcon={true} disabled>
          {localization.actions}
        </TableSortLabel>
      </TableCell>
    );
  }
  renderSelectionHeader() {
    const { classesStyle } = this.props;
    const selectionWidth = CommonValues.selectionMaxWidth(
      this.props,
      this.props.treeDataMaxLevel
    );

    return (
      <TableCell
        padding="none"
        key="key-selection-column"
        className={this.props.classes.tableHeader}
        style={{ ...this.props.headerStyle, width: 40, maxWidth: 40 }}
      >
        {this.props.showSelectAllCheckbox && (
          <Checkbox
            className={classesStyle.checkboxstyle}
            indeterminate={
              this.props.selectedCount > 0 &&
              this.props.selectedCount < this.props.dataCount
            }
            checked={
              this.props.dataCount > 0 &&
              this.props.selectedCount === this.props.dataCount
            }
            onChange={(event, checked) =>
              this.props.onAllSelected && this.props.onAllSelected(checked)
            }
            {...this.props.options.headerSelectionProps}
          />
        )}
      </TableCell>
    );
  }

  renderDetailPanelColumnCell() {
    return (
      <TableCell
        padding="none"
        key="key-detail-panel-column"
        className={this.props.classes.tableHeader}
        style={{ ...this.props.headerStyle }}
      />
    );
  }

  render() {
    const headers = this.renderHeader();
    if (this.props.hasSelection) {
      headers.splice(0, 0, this.renderSelectionHeader());
    }

    // if (this.props.showActionsColumn) {
    if (this.props.actions && this.props.actions.length !== 0) {
      if (this.props.actionsHeaderIndex >= 0) {
        let endPos = 0;
        if (this.props.hasSelection) {
          endPos = 1;
        }
        headers.splice(
          this.props.actionsHeaderIndex + endPos,
          0,
          this.renderActionsHeader()
        );
      } else if (this.props.actionsHeaderIndex === -1) {
        headers.push(this.renderActionsHeader());
      }
    }
    // }

    if (this.props.hasDetailPanel) {
      if (this.props.detailPanelColumnAlignment === "right") {
        headers.push(this.renderDetailPanelColumnCell());
      } else {
        headers.splice(0, 0, this.renderDetailPanelColumnCell());
      }
    }

    if (this.props.isTreeData > 0) {
      headers.splice(
        0,
        0,
        <TableCell
          padding="none"
          key={"key-tree-data-header"}
          className={this.props.classes.tableHeader}
          style={{ ...this.props.headerStyle }}
        />
      );
    }

    this.props.columns
      .filter((columnDef) => columnDef.tableData.groupOrder > -1)
      .forEach((columnDef) => {
        headers.splice(
          0,
          0,
          <TableCell
            padding="checkbox"
            key={"key-group-header" + columnDef.tableData.id}
            className={this.props.classes.tableHeader}
          />
        );
      });

    return (
      <TableHead style={{ position: "sticky", top: 0, zIndex: 10 }}>
        <TableRow>{headers}</TableRow>
      </TableHead>
    );
  }
}

MTableHeader.defaultProps = {
  dataCount: 0,
  hasSelection: false,
  headerStyle: {},
  selectedCount: 0,
  sorting: true,
  localization: {
    actions: "Actions",
  },
  orderBy: undefined,
  orderDirection: "asc",
  actionsHeaderIndex: 0,
  detailPanelColumnAlignment: "left",
  draggable: true,
  thirdSortClick: true,
};

MTableHeader.propTypes = {
  columns: PropTypes.array.isRequired,
  dataCount: PropTypes.number,
  hasDetailPanel: PropTypes.bool.isRequired,
  detailPanelColumnAlignment: PropTypes.string,
  hasSelection: PropTypes.bool,
  headerStyle: PropTypes.object,
  localization: PropTypes.object,
  selectedCount: PropTypes.number,
  sorting: PropTypes.bool,
  onAllSelected: PropTypes.func,
  onOrderChange: PropTypes.func,
  orderBy: PropTypes.number,
  orderDirection: PropTypes.string,
  actionsHeaderIndex: PropTypes.number,
  showActionsColumn: PropTypes.bool,
  showSelectAllCheckbox: PropTypes.bool,
  draggable: PropTypes.bool,
  thirdSortClick: PropTypes.bool,
  tooltip: PropTypes.string,
};

export const styles = (theme) => ({
  header: {
    // display: 'inline-block',
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.background.paper, // Change according to theme,
  },
});

export default withStyles(styles, { withTheme: true })(MTableHeader);
